import { createSelector } from 'reselect';
import { RootState } from 'store/reducer';

const themeSelector = (state: RootState) => state.theme;

export const selectBrandTheme = createSelector([themeSelector], theme => theme.theme);
